import React, { Component } from 'react';
import Section66to33Props from './Section66to33.props';
import Section66to33State from './Section66to33.state';

export default class Section66to33 extends Component<Section66to33Props, Section66to33State> {
    constructor(props: Section66to33Props) {
        super(props);
        this.state = {
            key: 'value'
        };
    }

    render(): React.ReactNode {
        return (
            <section className="cs-section-66to33 content-section">
                <div className="container">
                    <div className="section-66to33">
                        <div className="section-66to33__container">
                            <div className="section-66to33__intro">
                                <div className="textblock" 
                                    dangerouslySetInnerHTML={{__html: this.props.content100 || ''}}>
                                </div>
                            </div>
                            <div className="row section-66to33__row">
                                <div className="col-12 col-sm-6 col-lg-9 section-66to33__col">
                                    <div className="textblock" 
                                        dangerouslySetInnerHTML={{__html: this.props.content33 || ''}}>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-3 section-66to33__col">
                                    <div className="textblock" 
                                        dangerouslySetInnerHTML={{__html: this.props.content66 || ''}}>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
